<!--
    Program: BulletinTranslate.vue
    Author: SDL
    Description: 
    Created: 2020.03.13
-->

<template>
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <h2 class="pg_title">Service Bulletin - Mobile (English) Translation</h2>
            <div class="bc_ico">
                Home
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Engineer
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Service Bulletin
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Mobile (English) Translation
            </div>
            <!-- //contents_head -->
            <!-- detail_f tit -->
            <div class="sub_tit">Basic Info.</div>
            <!-- //detail_f tit -->
            <!-- detail_f -->
            <table class="create_table">
                <colgroup>
                    <col width="15%" />
                    <col width="*" />
                    <col width="15%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>Date</th>
                        <td>{{view.reg_dt}}</td>
                        <th>Register</th>
                        <td>{{view.reg_user_id}}</td>
                    </tr>
                    <tr>
                        <th>Type</th>
                        <td>{{view.type1}} / {{view.type2}}</td>
                        <th></th>
                        <th></th>
                    </tr>
                    <tr>
                        <th>Urgency</th>
                        <td>
                            <label
                                :class="{ txt_red: view.urgency_yn === 'Y' }"
                                v-if="view.urgency_yn === 'Y'"
                            >Urgent</label>
                            <label v-else>Normal</label>
                        </td>
                        <th>Need Translation</th>
                        <td>
                            <label
                                :class="{ txt_red: view.need_reprocess === 'Y' }"
                            >{{view.need_reprocess}}</label>
                        </td>
                    </tr>
                    <tr>
                        <th>Required Translations</th>
                        <td colspan="3" class="txt_red">{{view.tran}}</td>
                    </tr>
                    <tr>
                        <th>Title</th>
                        <td colspan="3">{{view.title}}</td>
                    </tr>
                    <tr>
                        <th>Tag Info</th>
                        <td colspan="3">{{view.tag_info}}</td>
                        <!-- <th>Sort</th>
                        <td>Move to the top</td>-->
                    </tr>
                    <tr>
                        <th>User Level</th>
                        <td colspan="3">
                            <ul class="ul_list max_scrollbar">
                                <li
                                    class="userlevel_txt"
                                    v-for="level in userLevelList"
                                    :key="level.CODE_ID"
                                >{{level.CODE_ID}} ({{level.CODE_NAME}})</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>Country / Region</th>
                        <td colspan="3">
                            <ul class="ul_list max_scrollbar">
                                <li
                                    class="userlevel_txt"
                                    v-for="country in countryList"
                                    :key="country"
                                >{{country}}</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>Contents</th>
                        <td colspan="3">
                            <cross-editor
                                editorId="bulletin"
                                :editorData="view.content || getBlankTemplate"
                            />
                        </td>
                    </tr>
                    <tr v-for="language in translationLanguages" :key="language">
                        <th>Attachment ({{language}})</th>
                        <td colspan="3" class="no_padding" >
                            <innorix-upload
                                v-if="toTranslateList.includes(language) && !isLoading[language]"
                                :id="'inno_'+language"
                                :name="'inno_'+language" 
                                :uploadId="language"
                                :onlyUpload="false"
                                :attachList="fileListByLanguage[language]"
                                @files="setAttachFiles"
                            />
                            <span v-else>No translation needed.</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- //detail -->
            <!-- page btn -->
            <div class="btn_wrap_full topLine">
                <a href="javascript:" class="btn_white" title @click="onBackToViewClick">View</a>
                <div class="btn_right">
                    <a href="javascript:" class="btn_blue" @click="onTranslateClick">Save Translation</a>
                </div>
            </div>
            <!-- //page btn -->
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import axios from 'axios';
import qs from 'query-string';

import store from '@/vuex/store';
import constants from '@/constants';
import SDLLocale from '@/mixin/SDLLocale';
import { SDLUtil, StringUtil, DateUtil, MenuUtil} from '@/utils';
import { EventBus } from '@/utils/EventBus';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import CrossEditor from '~c/CrossEditor';
import InnorixUpload from '~c/InnorixUpload';

import BlankPageTempPage from '/static/sample/CREATE_Template_04.html';

export default {
    name: 'hhp-bulletin-view',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'cross-editor': CrossEditor,
        'innorix-upload': InnorixUpload,
    },
    props: {
        seq: {
            type: String,
            required: true,
        },
        onBackToView: {
            type: Function,
        },
        // encToken: {
        //     type: String,
        //     required: true,
        // },
    },
    computed: {
        getGuid() {
            if (SDLUtil.isNull(this.guid)) {
                this.guid = StringUtil.guid();
            }
            return this.guid;
        },
        getUploadId() {
            if (SDLUtil.isNull(this.uploadId)) {
                this.uploadId = 'inno_' + this.getGuid;
            }
            return this.uploadId;
        },
        getBlankTemplate() {
            return BlankPageTempPage;
        },
        getDateformat() {
            return localStorage.getItem('mDateFormat');
        },
        ...mapGetters({
            locale: 'getLocale',
        }),
    },
    data() {
        return {

            language: 'Spanish',
            roleCd: '',
            view: {
                REG_DT: 'loading...',
                REG_USER_ID: 'loading...',
                URGENCY_YN: 'N',
                NEED_REPROCESS: 'Y',
                TYPE1: 'Guide',
                TYPE2: '',
                CONTENT: 'loading...',
                TITLE: 'loading...',
                TAG_INFO: 'loading...',
            },
            countryList: [],
            userLevelList: [],
            fileList: [],
            encToken: '',

            fileListByLanguage: {
                Spanish: [],
                French: [],
                German: [],
                Russian: [],
            },

            attachFilesByLanguage: {
                Spanish: {
                    attachFileSeq: [], // Attach files
                    delAttachFiles: [], // Delete attach files
                    isRemove: false, // Attach remove flag
                },
                French: {
                    attachFileSeq: [], // Attach files
                    delAttachFiles: [], // Delete attach files
                    isRemove: false, // Attach remove flag
                },
                German: {
                    attachFileSeq: [], // Attach files
                    delAttachFiles: [], // Delete attach files
                    isRemove: false, // Attach remove flag
                },
                Russian: {
                    attachFileSeq: [], // Attach files
                    delAttachFiles: [], // Delete attach files
                    isRemove: false, // Attach remove flag
                },
            },

            // attachFileSeq: [], // Attach files
            // delAttachFiles: [], // Delete attach files
            // isRemove: false, // Attach remove flag

            toTranslateList: [],
            translationLanguages: ['Spanish', 'French', 'German', 'Russian'],
            // translationLanguages: ['Spanish'],

            translationLanguageCodes: {
                Spanish: 1,
                French: 2,
                German: 3,
                Russian: 4,
                // 1: 'Spanish',
                // 2: 'French',
                // 3: 'German',
                // 4: 'Russian',
            },

            isLoading: {
                Spanish: true,
                French: true,
                German: true,
                Russian: true,
            },
        };
    },
    created() {
        this.init();
    },
    mounted() {
    },
    methods: {
        async init() {
            const data = await this.fetchData();
            this.setData(data);
            // this.setUserList(data.userLevelList, );
        },
        fetchData() {
            const params = {
                seq: this.seq,
            };

            return (
                axios
                    // Loads data such as list of countries, etc...
                    .get(`${SDLUtil.API_URL}/basis/anysvcmobile/svcBulletin/sbReprocess.skp`, { params })
                    .then(res => {
                        Vue.$log.info('SvcBulletin RESPONSE', res);
                        // res.data.rows => [['CODE_NAME', 'CODE_ID'], ...]
                        // console.log('LOG', this.availableParentCodeList);
                        return res.data;
                    })
                // .catch(err => {
                //     console.log(`SvcBulletin ERROR =>>`, err);
                //     return res.data;
                // })
            );
        },

        setData(data) {
            this.roleCd = data.roleCd;

            // console.log('this.view.tran', this.view.tran);
            this.countryList = data.country.map(item => item.COUNTRY_NM).sort();
            // console.log('countryList', this.countryList);
            this.userLevelList = data.userLevelList.map(item => {
                const matched = data.userLevelLabelList.find(i => i.CODE_ID === item.USER_LEVEL);
                return {
                    CODE_ID: item.USER_LEVEL,
                    CODE_NAME: matched ? matched.CODE_NAME : '',
                };
            });

            this.view = data.view;
            this.toTranslateList = data.view.tran
                .split(',')
                .filter(item => item)
                .map(item => item.replace(/ /g, ''));

            this.view.tran = this.toTranslateList.join(', ');
            this.view.content = SDLUtil.stripHtml(data.view.content);

            this.encToken = data.encToken;
            this.fileList = data.fileList;
            this.attachFileSeq = data.fileList;

            this.lazyLoadInnorix();

        },

        lazyLoadInnorix() {
            let delay = 500;

            this.toTranslateList.forEach(language => {
                window.setTimeout(() => {
                    this.isLoading[language] = false;
                }, delay += 100);
            });
        },

        onTranslateClick() {
            this.save();
        },

        async save() {
            if (!this.validateInput()) return;

            const formData = this.prepFormData();
            Vue.$log.info('formData', formData);

            const data = await SDLUtil.postForm('/basis/anysvcmobile/svcBulletin/sbReprocessProc.skp', formData);

            if (SDLUtil.isErrorResponse(data)) {
                SDLUtil.alert({
                    title: 'Error while Saving!',
                    msg: `${data.error.code} ${data.error.message}`,
                });
                return;
            }

            SDLUtil.alert({
                title: 'Success!',
                msg: data.message,
                onOkEvt: () => {
                    this.$router.push({
                        name: 'hhpServiceBulletinView',
                        query: {
                            seq: this.seq,
                        },
                    });
                },
            });
        },

        validateInput() {
            return true;
        },

        mergeFileList() {
            // let merged = []; // arr of FileSeq
            let merged = [
                ...this.attachFilesByLanguage['Spanish'].attachFileSeq,
                ...this.attachFilesByLanguage['French'].attachFileSeq,
                ...this.attachFilesByLanguage['German'].attachFileSeq,
                ...this.attachFilesByLanguage['Russian'].attachFileSeq,
            ].map(item => item.attachFileSeq);
            return merged;
        },

        prepFormData() {
            // console.log('subList', this.selectedSubsidiaryList);
            // const countryCodeList = this.selectedSubsidiaryList;

            const CEblankTxt = '<p><br></p>';
            const content = window.bulletin.GetBodyValue();
            if (content === CEblankTxt) {
                //invalid
            }

            const params = {
                seq: this.seq,
                TITLE: this.view.title,
                TYPE1: this.view.type1,
                TYPE2: this.view.type2,
                TAG_INFO: this.view.tag_info,
                URGENCY_YN: this.view.urgency_yn,
                REG_USER_ID: this.view.reg_user_id,
                REG_DT: this.view.reg_dt,
                // SUBSIDIARY: this.view.,
                // COUNTRY_VALUE_SPLIT: this.checkedCountryList.join(','),
                // COUNTRY_TEXT_SPLIT: this.checkedCountryList
                //     .map(code => this.availableCountryList.find(country => country.CDCODE === code).CDDESC)
                //     .join(','),
                // USER_LEVEL_SPLIT: this.checkedUserLevelList.join(','),
                NEED_REPROCESS: this.view.need_reprocess,
                CONTENT: content,
                attachFileSeq: this.mergeFileList(),
                attFileSeq : this.attachFilesByLanguage['Spanish'].attachFileSeq.map(item => '1'+item.attachFileSeq),
                attFileSeq2: this.attachFilesByLanguage['French'].attachFileSeq.map(item => '2'+item.attachFileSeq),
                attFileSeq3: this.attachFilesByLanguage['German'].attachFileSeq.map(item => '3'+item.attachFileSeq),
                attFileSeq4: this.attachFilesByLanguage['Russian'].attachFileSeq.map(item => '4'+item.attachFileSeq),
            };
            return params;
        },

        submit(formData) {
            return SDLUtil.postForm('/basis/anysvcmobile/svcBulletin/sbReprocessProc.skp', formData)
                .then(res => {
                    Vue.$log.info('POST FORM RESULT =>> ', res);
                    return res.data;
                })
                .catch(err => {
                    Vue.$log.error('POST FORM ERROR =>> ', err);
                    return err.data;
                });
        },

        onBackToViewClick() {
            if (typeof this.onBackToView === 'function') {
                this.onBackToView();
                return;
            }

            this.$router.push({
                name: 'hhpServiceBulletinView',
                query: {
                    seq: this.seq,
                },
            });
        },
        
        setAttachFiles(val) {
            Vue.$log.info('▶ InnorixUpload.vue -> BulletinTranslate.vue / files : ', val);
            this.attachFilesByLanguage[val.uploadId] = {
                attachFileSeq : val.fileList || [],
                delAttachFiles : val.delFileList || [],
                isRemove : val.isRemove || false,
            };
            // this.attachFileSeq = val.fileList || [];
            // this.delAttachFiles = val.delFileList || [];
            // this.isRemove = val.isRemove || false;
        },

    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/svcBulletin/BulletinTranslate.vue